import { connect } from 'react-redux';
import React, { Component } from 'react';
import {TreeNavRoot,TreeNavMenu,TreeNavMenuItem,TreeNavNodes} from 'react-fe-bootstrap';
import DocsRouteTree from './DocsRouteTree';
import {Select} from 'react-fe-bootstrap';
import imm from 'immutable';

class ApiList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selected:undefined,
      filterTags:null,
    }
    this.filterResources.bind(this);
    this.subFilterResources.bind(this);
    this.check_tags.bind(this);
  }

  check_tags(tags) {
    let stags = this.props.tags.filter((tag)=>!tag).keySeq().toJS();
    if(!this.props.tags || this.props.tags.length === 0 || stags.length === 0) {
      return true;
    } else if(tags.length === 0) {
      return false;
    }
    for(let tag of stags) {
      if(tags.indexOf(tag) === -1) {
        return false;
      }
    }
    return true;
  }

  subFilterResources(resources, tags, parent, parentKey) {
    let totalTags = _.union(tags, resources.tags);
    if(this.check_tags(totalTags)) {
      return;
    }
    for(let rkey in resources) {
      if(/^\//.test(rkey)) {
        this.subFilterResources(resources[rkey], totalTags, resources, rkey);
        if(resources[rkey] && Object.keys(resources[rkey]).length === 0 && resources[rkey].constructor === Object) {
          delete resources[rkey];
        }
      } else if(rkey !== 'methods') {
        delete resources[rkey];
      }
    }
    if(resources.methods) {
      for(let method in resources.methods) {
        let mTags = _.union(totalTags, resources.methods[method].tags, [method]);
        if(!this.check_tags(mTags)) {
          delete resources.methods[method];
        }
      }
      if(resources.methods.length === undefined && parent !== undefined && Object.keys(resources.methods).length === 0 && resources.methods.constructor === Object && Object.keys(resources).length === 1) {
        delete parent[parentKey];
      }
    }
  }

  filterResources(resources) {
    for(let key in resources) {
      for(let rkey in resources[key].routes) {
          if(/^\//.test(rkey)) {
            this.subFilterResources(resources[key].routes[rkey], [], resources[key].routes, rkey);
          } else {
            delete resources[key].routes[rkey];
          }
          if(resources[key].routes[rkey] && Object.keys(resources[key].routes[rkey]).length === 0 && resources[key].routes[rkey].constructor === Object) {
            delete resources[key].routes[rkey];
          }
      }
    }
  }

  render() {
    var resources = this.props.specs.toJS();
    this.filterResources(resources);
    let mspecs = imm.fromJS(resources);
    const tags = this.props.tags.keySeq().toJS().map((option) => ({tag: option.toString(), value: option.toString()}));
    return (
      <div>
      <div className="left-search-bar">
        <div className="left-search-bar__select">
          <Select
            labelKey="tag"
            onChange={(resp) => {
              this.props.onNewRequest(resp, this.props.tags);
              this.setState({
                filterTags:resp
              });
            }}
            value={this.state.filterTags}
            options={tags}
            clearable={false}
            placeholder="Search API File Path, Method or Tag"
            multi={true}
          />
        </div>
      </div>
      <TreeNavRoot {...this.props}>
        {
          mspecs.entrySeq().map(([spec_id, spec]) => {
            const api_name = spec.get('info').get('title');
            const api_version = spec.get('info').get('version');
            const base = spec.get('info').get('base') || spec_id;
            const text = `${api_name} - v${api_version}`;
            const routes = spec.get('routes');
            const path = `/${base}`;
            return <DocsRouteTree autoText={this.state.text} key={spec_id} spec_id={spec_id} spec={routes} text={text} path={path}/>;
          })
        }
      </TreeNavRoot>
      </div>
    );
  }
}

export default connect(
  state => (
    {
      tags: state.getIn(['tags', 'available'], {}),
      specs: state.get('apis').get('specs'),
      selected: state.get('apis').get('selected')
    }
  ),
  dispatch => (
    {
      onNewRequest(tag, available) {
        let tags = [];
        if(Array.isArray(tag)) {
           tags = tag.map((tagObj)=>tagObj.tag);
        } else {
           tags = [tag.tag];
        }
        let tagJS = available.toJS();
        for(let tag of available.keySeq().toJS()) {
           if(tags.indexOf(tag) !== -1) {
             dispatch({type: 'ADD_TAG_FILTER', data: tag});
           } else {
             dispatch({type: 'REMOVE_TAG_FILTER', data: tag});
           }
        }
      }
    }
  )
)(ApiList);
